import { lessonDiaryConstants } from '../../constants';

const initialLessonDiariesState = {
  lessonDiariesList: [] as any[],
};

export function lessonDiaries(state = initialLessonDiariesState, action: any) {
  switch (action.type) {
    case lessonDiaryConstants.GETALL_REQUEST:
      return { ...state, loading: true };
    case lessonDiaryConstants.GETALL_SUCCESS:
      return { ...state, lessonDiariesList: action.payload, loading: false };
    case lessonDiaryConstants.GETALL_FAILURE:
      return { ...state, error: action.payload, loading: false };
    
    case lessonDiaryConstants.CREATE_REQUEST:
      return { ...state, loading: true };
    case lessonDiaryConstants.CREATE_SUCCESS:
      return { 
        ...state, 
        lessonDiariesList: [...state.lessonDiariesList, action.payload],
        loading: false 
      };
    case lessonDiaryConstants.CREATE_FAILURE:
      return { ...state, error: action.error, loading: false };
    
    case lessonDiaryConstants.UPDATE_REQUEST:
      return { ...state, loading: true };
    case lessonDiaryConstants.UPDATE_SUCCESS:
      return { 
        ...state, 
        lessonDiariesList: state.lessonDiariesList.map(diary =>
          diary.id === action.payload.id ? action.payload : diary
        ),
        loading: false
      };
    case lessonDiaryConstants.UPDATE_FAILURE:
      return { ...state, error: action.error, loading: false };
    
    case lessonDiaryConstants.DELETE_REQUEST:
      return { ...state, loading: true };
    case lessonDiaryConstants.DELETE_SUCCESS:
      return { 
        ...state, 
        lessonDiariesList: state.lessonDiariesList.filter(diary => diary.id !== action.payload),
        loading: false
      };
    case lessonDiaryConstants.DELETE_FAILURE:
      return { ...state, error: action.error, loading: false };
    
    default:
      return state;
  }
}
